/**
 * `TargetingConfig` carries two discriminants, and neither is dependable: `type` is the Jackson
 * discriminator and is optional on the wire, and `__typename` is only added by the CHIRP Avro
 * gateway. Rather than discriminating on either, we key off `objectTypeAndId`, which only the CRM
 * object targeting config declares, so a CRM targeted variant resolves whichever discriminant its
 * response happens to carry.
 */
export const getCrmObjectTarget = targetingConfig => {
  const target = targetingConfig === null || targetingConfig === void 0 ? void 0 : targetingConfig.objectTypeAndId;
  return target !== null && target !== void 0 && target.objectTypeId && target.objectId != null ? target : undefined;
};
export const getCrmObjectTargets = variants => variants.map(variant => getCrmObjectTarget(variant.targetingConfig)).filter(target => Boolean(target));